import { Reveal, Eyebrow } from "@/components/Reveal";

const TILES = [
  {
    src: "https://images.unsplash.com/photo-1589778655375-3e622a9fc91c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    caption: "Ghee Podi Idli",
    span: "md:col-span-7",
    height: "h-72 md:h-[420px]",
  },
  {
    src: "https://images.unsplash.com/photo-1613158556069-e7d8eae76214?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
    caption: "Degree Filter Coffee",
    span: "md:col-span-5",
    height: "h-72 md:h-[420px]",
  },
  {
    src: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
    caption: "The Spice Atelier",
    span: "md:col-span-4",
    height: "h-72 md:h-[340px]",
  },
  {
    src: "https://images.unsplash.com/photo-1680946496238-5272d3c407fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
    caption: "The Dining Room",
    span: "md:col-span-4",
    height: "h-72 md:h-[340px]",
  },
  {
    src: "https://images.unsplash.com/photo-1657593088889-5105c637f2a8?crop=entropy&cs=srgb&fm=jpg&q=85&w=700",
    caption: "Family Gatherings",
    span: "md:col-span-4",
    height: "h-72 md:h-[340px]",
  },
];

const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Eyebrow>Gallery</Eyebrow>
          <h2 className="mt-4 max-w-xl font-display text-3xl font-medium leading-tight tracking-tight sm:text-4xl md:text-5xl">
            Brass, banana leaf
            <span className="text-gradient-saffron italic"> & the glow of the tava.</span>
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-zinc-400">
          A glimpse inside Podi Sambaram — where every meal arrives on a leaf
          and every coffee is frothed in a dabara.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-12">
        {TILES.map((tile, i) => (
          <Reveal key={tile.caption} delay={0.07 * i} className={tile.span}>
            <figure
              data-testid={`gallery-tile-${i}`}
              className={`group relative ${tile.height} overflow-hidden rounded-3xl border border-white/10`}
            >
              <img
                src={tile.src}
                alt={tile.caption}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-108 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
              <figcaption className="absolute bottom-5 left-5 flex items-center gap-3">
                <span className="h-px w-8 bg-[#F57C00]" />
                <span className="font-display text-lg font-semibold text-white">
                  {tile.caption}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
